import React from 'react'
import './index.css'
import logEventAnalyticsUtil from 'utils/analytics/log-event'
import useSelector from 'hooks/use-selector'
import getSubtotalCartSelector from 'modules/cart/redux/selectors/get-subtotal'
import View from 'components/View'
import { ProgressBarWithIndicatorAndLabels } from 'components/ProgressBarWithIndicatorAndLabels'

const ANALYTICS_EVENT = {
  SHOW_PRODUCT_AOV_UNLOCK_PROGRESS_BAR: 'SHOW_PRODUCT_AOV_UNLOCK_PROGRESS_BAR',
  PRODUCT_AOV_SHOW_MORE_TO_UNLOCK: 'PRODUCT_AOV_SHOW_MORE_TO_UNLOCK',
  CLOSE_PRODUCT_AOV_UNLOCK_PROGRESS_BAR: 'CLOSE_PRODUCT_AOV_UNLOCK_PROGRESS_BAR'
}

/**
 * @param aovLock
 * @returns {JSX.Element}
 * @constructor
 */
export default function ProductAOVUnlockProgressBar ({
  aovLock
}) {
  const subtotal = useSelector(getSubtotalCartSelector())

  const handleMount = () => {
    logEventAnalyticsUtil(ANALYTICS_EVENT.SHOW_PRODUCT_AOV_UNLOCK_PROGRESS_BAR)
  }

  React.useEffect(() => {
    handleMount()
  }, [])

  const progressPercentage = Math.min((subtotal / aovLock) * 100, 100)
  return (
    <>
      <View className='product-aov-unlock-progres-bar'>
        <View className='product-aov-unlock-progres-bar-content'>
          <View className='product-aov-unlock-progres-bar-content-text-and-icon'>
            <svg
              width='24'
              height='24'
              viewBox='0 0 24 24'
              fill='none'
              xmlns='http://www.w3.org/2000/svg'
            >
              <path
                d='M11.4 8.3999L4.20001 18.5999L6.00001 22.1999H11.4L19.8 10.1999L16.8 8.9999L11.4 8.3999Z'
                fill='#FFC1F1'
              />
              <path
                d='M12 16.0001V18.0001M7.5 22.0001H16.5005C18.1573 22.0001 19.5005 20.6569 19.5005 19.0001V11.6667C19.5005 10.0099 18.1573 8.66675 16.5005 8.66675H7.5C5.84315 8.66675 4.5 10.0099 4.5 11.6667V19.0001C4.5 20.6569 5.84315 22.0001 7.5 22.0001ZM13.5 14.0001C13.5 14.8285 12.8284 15.5001 12 15.5001C11.1716 15.5001 10.5 14.8285 10.5 14.0001C10.5 13.1716 11.1716 12.5001 12 12.5001C12.8284 12.5001 13.5 13.1716 13.5 14.0001Z'
                stroke='#191531'
                strokeWidth='1.5'
                strokeLinecap='round'
                strokeLinejoin='round'
              />
              <path
                d='M9.48776 8.49853L8.83689 5.65555C8.37469 3.63664 9.63664 1.62531 11.6555 1.16311C13.6744 0.700901 15.6858 1.96286 16.148 3.98176'
                stroke='#191531'
                strokeWidth='1.5'
                strokeLinecap='round'
                strokeLinejoin='round'
              />
            </svg>

            <View className='product-aov-unlock-progres-bar-content-text'>
              Yay! You’ve unlocked this sample.
            </View>

          </View>
          <ProgressBarWithIndicatorAndLabels
            minLabel='$0'
            maxLabel={`$${parseInt(aovLock, 10)}`}
            progress={progressPercentage}
          />
        </View>
      </View>
    </>
  )
}
